// src/components/ChakraIcon.tsx
import { Icon, IconProps } from "@chakra-ui/react";
import type { IconType } from "react-icons";
import type { ComponentType, SVGProps } from "react";
import React from "react";

interface ChakraIconWrapperProps extends Omit<IconProps, "as"> {
  /** Pass any react-icons IconType here; we’ll cast internally. */
  as: IconType;
}

/** 
 * ChakraIcon wraps a react-icons IconType inside Chakra’s <Icon>,
 * so TS sees a valid ComponentType<SVGProps<SVGSVGElement>>.
 */
export function ChakraIcon({ as, ...props }: ChakraIconWrapperProps) {
  return <Icon as={as as unknown as ComponentType<SVGProps<SVGSVGElement>>} {...props} />;
}
